import { isSupportedFile } from "@/pages/home/utils/convert-file-to-pdf";

// Shared by source-step.tsx and import-file-button.tsx so the picker's file
// filter always matches what the validator below accepts.
export const IMPORT_FILE_ACCEPT =
  ".pdf,.docx,.doc,.pptx,.ppt,.txt,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,text/plain";

// Mirrors the backend MAX_PDF_BYTES so the oversized message fires before upload.
export const MAX_IMPORT_FILE_BYTES = 25 * 1024 * 1024;

export const UNSUPPORTED_TYPE_MESSAGE =
  "Wrong file format. Please select a PDF, Word, PowerPoint, or text file.";
export const OVERSIZED_MESSAGE = "This file is too large. The limit is 25 MB.";

export const validateImportFile = (
  file: File,
): { ok: true } | { ok: false; reason: "type" | "size"; message: string } => {
  if (!isSupportedFile(file))
    return { ok: false, reason: "type", message: UNSUPPORTED_TYPE_MESSAGE };
  if (file.size > MAX_IMPORT_FILE_BYTES)
    return { ok: false, reason: "size", message: OVERSIZED_MESSAGE };
  return { ok: true };
};
